import api from './config';

export const productsAPI = {
  // Listar todos os produtos
  getAll: async (params = {}) => {
    const response = await api.get('/products', { params });
    return response.data;
  },

  // Buscar produto por ID
  getById: async (id) => {
    const response = await api.get(`/products/${id}`);
    return response.data;
  },

  // Criar novo produto
  create: async (productData) => {
    const response = await api.post('/products', productData);
    return response.data;
  },

  // Atualizar produto
  update: async (id, productData) => {
    const response = await api.put(`/products/${id}`, productData);
    return response.data;
  },

  // Deletar produto
  delete: async (id) => {
    const response = await api.delete(`/products/${id}`);
    return response.data;
  },

  // Produtos com estoque baixo
  getLowStock: async () => {
    const response = await api.get('/products/alerts/low-stock');
    return response.data;
  },

  // Buscar produtos (com filtros)
  search: async (filters) => {
    const response = await api.get('/products', { params: filters });
    return response.data;
  },
};

export default productsAPI;


